import { useState } from 'react';
import { Button, Card, CardContent } from '../components/ui';
import { Leaderboard } from '../components/highscores';
import { useAuth } from '../stores/auth.store';

// Available games (will come from API/config later)
const GAMES = [
  { id: 'snake', name: 'Snake', icon: '🐍' },
  { id: 'falling-blocks', name: 'Falling Blocks', icon: '🧱' },
  { id: 'wall-breaker', name: 'Wall Breaker', icon: '🧱' },
  { id: 'pill-muncher', name: 'Pill Muncher', icon: '👻' },
  { id: 'blasteroids', name: 'Blasteroids', icon: '🚀' },
  { id: 'invaders', name: 'Invaders!', icon: '👾' },
  { id: 'tennis', name: 'Tennis', icon: '🏓' },
  { id: 'flappy', name: 'Flapping Chick', icon: '🐦' },
];

type TimeFilter = 'all' | 'daily' | 'weekly' | 'monthly';

export function LeaderboardsPage() {
  const { user } = useAuth();
  const [selectedGame, setSelectedGame] = useState(GAMES[0].id);
  const [timeFilter, setTimeFilter] = useState<TimeFilter>('all');

  const selectedGameInfo = GAMES.find((g) => g.id === selectedGame);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">Leaderboards</h1>
        <p className="text-slate-400">
          See how you stack up against other players
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Sidebar - Game Selection */}
        <div className="lg:col-span-1 space-y-4">
          <Card>
            <CardContent>
              <h3 className="font-semibold text-white mb-3">Select Game</h3>
              <div className="space-y-1">
                {GAMES.map((game) => (
                  <button
                    key={game.id}
                    onClick={() => setSelectedGame(game.id)}
                    className={`
                      w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left transition-colors
                      ${
                        selectedGame === game.id
                          ? 'bg-purple-500/20 text-purple-400 border border-purple-500/30'
                          : 'text-slate-300 hover:bg-slate-700/50'
                      }
                    `}
                  >
                    <span className="text-xl">{game.icon}</span>
                    <span>{game.name}</span>
                  </button>
                ))}
              </div>
            </CardContent>
          </Card>

          {/* Time Filter */}
          <Card>
            <CardContent>
              <h3 className="font-semibold text-white mb-3">Time Period</h3>
              <div className="flex flex-wrap gap-2">
                {(
                  [
                    { id: 'all', label: 'All Time' },
                    { id: 'daily', label: 'Today' },
                    { id: 'weekly', label: 'This Week' },
                    { id: 'monthly', label: 'This Month' },
                  ] as const
                ).map((filter) => (
                  <Button
                    key={filter.id}
                    size="sm"
                    variant={timeFilter === filter.id ? 'primary' : 'ghost'}
                    onClick={() => setTimeFilter(filter.id)}
                  >
                    {filter.label}
                  </Button>
                ))}
              </div>
              {timeFilter !== 'all' && (
                <p className="text-xs text-slate-500 mt-2">
                  Note: Time filters coming soon
                </p>
              )}
            </CardContent>
          </Card>
        </div>

        {/* Main Content - Leaderboard */}
        <div className="lg:col-span-3">
          <Leaderboard
            gameId={selectedGame}
            gameName={selectedGameInfo?.name}
            limit={25}
            highlightUserId={user?.id}
          />
        </div>
      </div>
    </div>
  );
}
